import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ENVIRONMENT } from '../../injection-tokens';
import { PaymentsRouteSegments, SharedRouteSegments } from 'src/app/shared/constants';

export const paymentsEnabledGuard: CanActivateFn = (_, state) => {
  const environment = inject(ENVIRONMENT);
  const router = inject(Router);

  const maintenanceUrlTree = router.createUrlTree([PaymentsRouteSegments.payments, SharedRouteSegments.maintenance]);

  if (state.url === router.serializeUrl(maintenanceUrlTree)) {
    if (environment.paymentsEnabled) {
      return router.createUrlTree([PaymentsRouteSegments.payments]);
    }

    return true;
  }

  if (environment.paymentsEnabled) {
    return true;
  }

  return maintenanceUrlTree;
};
